var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-autocomplete',_vm._g(_vm._b({attrs:{"filter":"","items":_vm.options,"label":_vm.$t('debtor'),"label-icon":"icon-clients","hide-details":"","multiple":"","dense":"","solo":""}},'app-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }